import { HttpClient } from '@core/httpClient';
import { END_POINTS } from '@services/urls';

import { buildPathWithParams } from '@utils/urls';

import { TPaymentDetails } from './types';

export class PaymentService {
  public static getPaymentDetails = async (paymentExternalId: string): Promise<TPaymentDetails> => {
    try {
      const response = await HttpClient.GET<TPaymentDetails>({
        url: buildPathWithParams(END_POINTS.paymentDetails, { paymentExternalId }),
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
